import React, { useEffect, useState } from 'react';
import { Row, Col} from "react-bootstrap";
import { toast } from 'react-toastify';

import { ConsultaAsiento, EditAsiento } from "../../../funciones/EstCuentaFunction";

const EditarAsiento = (props) => {
    const [preloader, setPreloader] = useState(<React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando detalles del asiento</React.Fragment>);
    const [itemDisabled, setItemDisabled] = useState(true);
    const [fecha, setFecha] = useState("");
    const [item, setItem] = useState("");
    const [debe, setDebe] = useState("");
    const [haber, setHaber] = useState("");
    const [saldo, setSaldo] = useState("");
    const [boton, setBoton] = useState({icon: "fa fa-save", text: "Editar", disabled: false})

    useEffect(() => {
        ConsultaAsiento (props.id, (resp) => {
            setPreloader("")
            setItemDisabled(false)
            setFecha(resp.fecha)
            setItem(resp.item)
            setDebe(resp.debe)
            setHaber(resp.haber)
            setSaldo(resp.saldo)
            
        })
    }, []);

    let edit = () => {
        if (boton.disabled === true || preloader !== "") return null;
        
        let errores = 0;
        if(fecha === "" || item === "") errores++

        if (errores > 0){
           toast.error("Faltan campos por llenar", {autoClose: 4000});
        }else{
            setBoton({icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true})
            EditAsiento(props.id, fecha, item, debe, haber, saldo, (resp) => {
                toast[resp.status](resp.mess, {autoClose: 4000});
                props.funcionOk(false)
            })
        }
        
    }

    return (
        <React.Fragment>
            <div align="right" className="text-danger">{preloader}</div>
            <Row>
                <Col md = {3}>
                    <input type = "text" className="form-control" maxLength={10} disabled = {itemDisabled} value = {fecha} onChange={(e) => {setFecha(e.target.value)}}/>
                    <div className="text-danger" style={{fontSize: 10}}>Fecha</div>
                </Col>
                <Col md = {9}>
                    <input type = "text" className="form-control" disabled = {itemDisabled} value = {item} onChange={(e) => {setItem(e.target.value)}}/>
                    <div className="text-danger" style={{fontSize: 10}}>Item</div>
                </Col>
                <Col md = {4} className="custom-mt-10">
                    <input type = "number" className="form-control" disabled = {itemDisabled} value = {debe} onChange={(e) => {setDebe(e.target.value)}}/>
                    <div className="text-danger" style={{fontSize: 10}}>Facturado</div>
                </Col>
                <Col md = {4} className="custom-mt-10">
                    <input type = "number" className="form-control" disabled = {itemDisabled} value = {haber} onChange={(e) => {setHaber(e.target.value)}}/>
                    <div className="text-danger" style={{fontSize: 10}}>Pagado</div>
                </Col>
                <Col md = {4} className="custom-mt-10">
                    <input type = "number" className="form-control" disabled = {itemDisabled} value = {saldo} onChange={(e) => {setSaldo(e.target.value)}}/>
                    <div className="text-danger" style={{fontSize: 10}}>Saldo</div>
                </Col>
                <Col md={12} align = "right" className="custom-mt-10" style={{marginBottom: 10}}>
                    <button className="btn btn-warning" style={{borderWidth:1}} onClick={() => {edit()}} title="Guardar cambios"><i className={boton.icon}></i> {boton.text}</button>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default EditarAsiento;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/EditarAsiento.jsx